// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"a968b1d6","400":"a968b1d6"}[chunkId] + ".chunk.css";
};